import React from 'react'
import type { InlineInputProps } from '@ztechapps/webui.input'
import { InlineInput } from '@ztechapps/webui.input'
import type { SetOptional } from 'type-fest'
import type { SelectOption } from '@ztechapps/webui.input'
import { unitOfMeasureQueries } from '@ztechapps/product.common'

export type UnitOfMeasureInlineInputProps = SetOptional<InlineInputProps, 'mutationConfig'> & {
  selectOptions?: SelectOption[]
}

export const UnitOfMeasureInlineInput = ({
  parentInputComponent,
  mutationConfig,
  ...rest
}: UnitOfMeasureInlineInputProps) => {
  const ParentInput = parentInputComponent || InlineInput

  if (!mutationConfig) {
    mutationConfig = unitOfMeasureQueries.updateConfig
  }

  return <ParentInput {...{ mutationConfig, ...rest }} />
}
